
"use client";
import React from 'react'
import Reveal from "./Reveal";


const AdmissionProcess = () => {
  const steps = [
    { num: "01", title: "Application Screening", desc: "Eligibility & research alignment check", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Application-Screening.webp" },
    { num: "02", title: "Research Aptitude Test", desc: "MCQ-based qualifying test", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Research-Aptitude-Test.webp" },
    { num: "03", title: "Viva-Voce Interview", desc: "DRC evaluation of research proposal", img: "https://cdn.msu.edu.in/msu-reavamp/phd/Viva-Voce-Interview.webp" },
  ];
  return (
    <section className="py-14 md:py-20 bg-[#F8FAFC]">
      <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto">
        <Reveal className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-8 h-0.5 bg-[#FFA201]" />
            <span className="text-[#0475B3] text-xs font-black uppercase tracking-widest">Admission Process</span>
            <div className="w-8 h-0.5 bg-[#FFA201]" />
          </div>
          <h2 className="text-4xl font-black text-[#073451]">3 Steps to Enrol</h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 relative">
          <div className="hidden md:block absolute top-24 left-[calc(16.6%+1rem)] right-[calc(16.6%+1rem)] h-0.5 bg-linear-to-r from-[#0475B3] via-[#FFA201] to-[#0475B3]" />
          {steps.map((step, i) => (
            <Reveal key={step.num} delay={i * 120}>
              <div className="bg-white rounded-sm overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                <div className="relative h-50 overflow-hidden">
                  <img src={step.img} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-[#081E2D]/60" />
                  <div className="absolute top-3 left-3 bg-[#FFA201] text-[#081E2D] text-xl font-black w-10 h-10 rounded-xl flex items-center justify-center">
                    {step.num}
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-black text-[#081E2D] mb-2 text-lg">{step.title}</h3>
                  <p className="text-gray-500 text-md leading-normal">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AdmissionProcess